/**
 * Map of query keys use by the react-query hooks.
 */
export const queryKeys = {
    activities: 'activities',
    addToPlaylistTooltipSeen: 'addToPlaylistTooltipSeen',
    allWorkflowInstances: 'allWorkflowInstances',
    accountSync: 'accountSync',
    checkinEntries: 'checkinEntries',
    checkinEntriesLatest: 'checkinEntriesLatest',
    checkinEntry: 'checkinEntry',
    checkinTypeSummary: 'checkinTypeSummary',
    circles: 'circles',
    circleById: 'circleById',
    countries: 'countries',
    dependentPartnerById: 'dependentPartnerById',
    deviceConsent: 'deviceConsent',
    recommendations: 'recommendations',
    recCollections: 'recCollections',
    referrals: 'referrals',
    workflowByDefnId: 'workflowByDefnId',
    workflowByType: 'workflowByType',
    workflowNextStepByDefnId: 'workflowNextStepByDefnId',
    workflowPreviousStepByDefnId: 'workflowPreviousStepByDefnId',
    packsByPackClass: 'packsByPackClass',
    feedsByFeedIds: 'feedsByFeedIds',
    recipientPrograms: 'recipientPrograms',
    forYouRecommendations: 'forYouRecommendations',
    clinicalPacksByPackClass: 'clinicalPacksByPackClasses',
    mediaCookies: 'mediaCookies',
    conditions: 'conditions',
    dailies: 'dailies',
    dailiesIndexes: 'dailiesIndexes',
    sleepStories: 'sleepStories',
    discoverSections: 'discoverSections',
    genders: 'genders',
    goals: 'goals',
    guides: 'guides',
    invitations: 'invitations',
    invitationByCode: 'invitationByCode',
    invitationById: 'invitationById',
    mostRecentSponsorship: 'mostRecentSponsorship',
    needsRegistrationConsent: 'needsRegistrationConsent',
    notificationPreferences: 'notificationPreferences',
    notificationUser: 'notificationUser',
    poll: 'poll',
    pollSubmission: 'pollSubmission',
    pollStaticContent: 'pollStaticContent',
    productsByUserId: 'userProducts',
    programs: 'programs',
    programMetadatas: 'programMetadatas',
    playlists: 'playlists',
    playlistById: 'playlistById',
    publicNarrators: 'publicNarrators',
    publicProgram: 'publicProgram',
    publicBrandingPartnerConfig: 'publicBrandingPartnerConfig',
    partnerByCode: 'partnerByCode',
    partnerById: 'partnerById',
    partnerEligibility: 'partnerEligibility',
    refreshAccessToken: 'refreshAccessToken',
    recentAndFavoriteGuides: 'recentAndFavoriteGuides',
    tosCohortConsent: 'tosCohortConsent',
    tokenData: 'tokenData',
    transitionDialogDismissal: 'transitionDialogDismissal',
    videoBackground: 'videoBackground',
    healthSummary: 'healthSummary',
    healthSummarySignedUrl: 'healthSummarySignedUrl',
    previousRegistrationFlow: 'previousRegistrationFlow',
    unsponsoredConfig: 'unsponsoredConfig',
    search: 'search',
    searchTrending: 'searchTrending',
    searchTypeahead: 'searchTypeahead',
    searchResults: 'searchResults',
    resources: 'resources',
    rewards: 'rewards',
    ftueWorkflowSteps: 'ftueWorkflowSteps',
    aiRecommendations: 'aiRecommendations',
    aiConversations: 'aiConversations',
    aiConversationItems: 'aiConversationItems',
    quotes: 'quotes',
    aiFeedback: 'aiFeedback',
    bffPopularWithListeners: 'bffPopularWithListeners',
    journalingTimeSpent: 'journalingTimeSpent',
    shortcuts: 'shortcuts',
};
